// 酒精销售许可证
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'
import qualificationScopeListOptions from '@/pages/shopDetail/config/qualificationScopeListOptions'
import qualificationIsCustomOpenDateList from '@/pages/shopDetail/config/qualificationIsCustomOpenDateList'
import qualificationScopeList from '@/pages/shopDetail/config/qualificationScopeList'
import { DAYS_MAP } from '@/consts'

function formatScopeList (wine) {
  if (!wine.scope) {
    return qualificationScopeList.val2text(wine.scope)
  }
  return wine.scopeList.reduce((acc, cur) => {
    acc.push(qualificationScopeListOptions.val2text(cur))
    return acc
  }, [])
}

function formatOpenDate (wine) {
  if (!wine.isCustomOpenDate || !wine.openDate) {
    return qualificationIsCustomOpenDateList.val2text(wine.isCustomOpenDate)
  }
  if (!wine.openDate.length) return
  return wine.openDate.map(itemDate => {
    const { label, timeRanges } = itemDate
    if (!label || !label.length || !timeRanges || !timeRanges.length) {
      return ''
    }
    const labelMessage = label
      .filter(item => DAYS_MAP[item])
      .map(item => DAYS_MAP[item])
      .join('、')
    const timeRangesMessage = timeRanges
      .filter(({ startTime, endTime }) => startTime && endTime)
      .map(({ startTime, endTime }) => `${startTime}-${endTime}`)
      .join(' </br> ')
    return `${labelMessage} </br> ${timeRangesMessage}`  
  }).join('</br>')
}

export default (state) => {
  let wine = get(state, 'currentShopBaseDetail.docInfo.wine', {})
  return {
    title: i18n.gettext('酒精销售许可证'),
    detail: wine,
    content: [
      // {
      //   title: i18n.gettext('餐厅名称'),
      //   label: sell.resName
      // },
      // {
      //   title: i18n.gettext('餐厅地址'),
      //   label: sell.resAddr
      // },
      {
        title: i18n.gettext('许可证有效期'),
        label: wine.validateDate
      },
      {
        title: i18n.gettext('范围'),
        label: formatScopeList(wine)
      },
      {
        title: i18n.gettext('售卖时间'),
        slot: formatOpenDate(wine)
      },
      {
        title: i18n.gettext('执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: wine.licensePics
      }
    ]
  }
}
